import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { RouteComponentProps, withRouter } from 'react-router';
import { Form, Input, Modal, notification, Row, Tabs, Checkbox } from 'antd';

import { parseLetterData } from '../../helpers/parseLetterData';
import CreateOrderItemEditor from '../OrderItems/OrderItemsEditors/CreateOrderItemEditor2';
import UpdateOrderItemEditor from '../OrderItems/OrderItemsEditors/UpdateOrderItemEditor2';
import OrderInformation from './OrderView/OrderInformation';
import OrderInvoices from './OrderView/OrderInvoices';
import { ICreateOrderItem, ICreateNonProductOrderItem } from 'data-layer/src/services/OrderItems/interfaces/ICreateOrderItem';
import { IUpdateOrderItem, IUpdateNonProductOrderItem } from 'data-layer/src/services/OrderItems/interfaces/IUpdateOrderItem';
import CreateNonProductOrderItemEditor from '../OrderItems/OrderItemsEditors/CreateNonProductOrderItemEditor';
import UpdateNonProductOrderItemEditor from '../OrderItems/OrderItemsEditors/UpdateNonProductOrderItemEditor';

interface IOrderProps extends RouteComponentProps<{ orderId: string; eshop: string }> {
  order: any;
  attributes: any;
  orderComments: any;

  updateOrder?: MutationFunc;
  changeState?: MutationFunc;
  createOrderComment?: MutationFunc;

  createOrderItem: MutationFunc;
  createNonProductOrderItem: MutationFunc;
  updateOrderItem: MutationFunc;
  updateNonProductOrderItem: MutationFunc;
  deleteOrderItem: MutationFunc;

  sendOrderEmail: MutationFunc;
  uploadToPohoda: MutationFunc;
  uploadQBPurchaseOrder: MutationFunc;
}

interface IOrderViewState {
  letterData?: GQL.ILetterData;

  editOrderItem?: GQL.IOrderItem;
  createOrderItem: boolean;
  createNonProductOrderItem: boolean;
}

class OrderView extends React.Component<IOrderProps, IOrderViewState> {

  constructor(props: IOrderProps) {
    super(props);

    this.state = {
      createOrderItem: false,
      createNonProductOrderItem: false,
    };

    this.onUpdate = this.onUpdate.bind(this);
    this.onChangeExternalOrderState = this.onChangeExternalOrderState.bind(this);
    this.onUploadToPohoda = this.onUploadToPohoda.bind(this);
    this.onUploadPurchaseQBOrder = this.onUploadPurchaseQBOrder.bind(this);
  }

  public render() {
    if (this.props.order.loading || !this.props.order) {
      return <h3>Loading...</h3>;
    }

    return (
      <div>
        {this.state.createOrderItem && (
          <CreateOrderItemEditor 
            onCreate={(data: ICreateOrderItem) => this.createOrderItem(data)} 
            onCancel={() => this.setState({ createOrderItem: false })} 
          />
        )}
        {this.state.createNonProductOrderItem && (
          <CreateNonProductOrderItemEditor
            order={this.props.order && this.props.order.order}
            onCreate={(data: ICreateNonProductOrderItem) => this.createNonProductOrderItem(data)} 
            onCancel={() => this.setState({ createNonProductOrderItem: false })} 
          />
        )}

        {this.state.editOrderItem && 
          <React.Fragment>
            {this.state.editOrderItem.product &&
              <UpdateOrderItemEditor
                item={this.state.editOrderItem}
                order={this.props.order && this.props.order.order}
                onUpdate={(data: IUpdateOrderItem) => this.updateOrderItem(data)}
                onCancel={() => this.setState({ editOrderItem: undefined })}
              />}
            {!this.state.editOrderItem.product &&
              <UpdateNonProductOrderItemEditor
                item={this.state.editOrderItem}
                order={this.props.order && this.props.order.order}
                onUpdate={(data: IUpdateNonProductOrderItem) => this.updateNonProductOrderItem(data)}
                onCancel={() => this.setState({ editOrderItem: undefined })}
              />}
          </React.Fragment>}

        <Modal
          style={{ top: '5vh' }}
          maskClosable={false}
          width={'50%'}
          title={'Let customer know'}
          visible={this.state.letterData !== undefined && this.state.letterData !== null}
          cancelText={'Close'}
          okText={'Send message'}
          onOk={() => this.sendMessage()}
          onCancel={() => this.setState({ letterData: undefined })}
        >
          <Row>
            <Form layout={'horizontal'}>
              <Form.Item label={'Subject'} style={{ width: '100%' }}>
                <Input onChange={e => this.onChangeSubject(e.currentTarget.value, this.props.order.order.language)} value={this.getSubject()} />
              </Form.Item>
              <Form.Item label={'Text'} style={{ width: '100%' }}>
                <Input.TextArea
                  value={this.getMessage()}
                  autoFocus={true}
                  autoSize={true}
                  style={{ height: '100%', minHeight: '450px' }}
                  onChange={e => this.onChangeMessage(e.currentTarget.value, this.props.order.order.language)}
                />
              </Form.Item>
              <Form.Item>
                <Checkbox
                  name={'attachmentInvoice'}
                  checked={this.state.letterData ? this.state.letterData.attachmentInvoice === true : false}
                  onChange={(e: any) => this.onChangeAttachment('attachmentInvoice', e.target.checked)}
                > 
                  Insert invoice to email attachment
                </Checkbox>
              </Form.Item>
              <Form.Item>
                <Checkbox
                  name={'attachmentProforma'}
                  checked={this.state.letterData ? this.state.letterData.attachmentProforma === true : false}
                  onChange={(e: any) => this.onChangeAttachment('attachmentProforma', e.target.checked)}
                > 
                  Insert proforma invoice to email attachment
                </Checkbox>
              </Form.Item>
            </Form>
          </Row>
        </Modal>

        <Tabs>
          <Tabs.TabPane key={'1'} tab={`Order #${this.props.order && this.props.order.order && this.props.order.order.orderNumber}`}>
            <OrderInformation
              onNewComment={(comment, sendEmail) => this.sendComment(comment, sendEmail)}
              onUploadToPohoda={this.onUploadToPohoda}
              onUploadPurchaseQBOrder={this.onUploadPurchaseQBOrder}
              orderComments={this.props.orderComments.orderComments ? this.props.orderComments.orderComments : []}
              onUpdate={this.onUpdate}
              onChangeExternalOrderState={this.onChangeExternalOrderState}
              order={this.props.order.order}
              attributes={this.props.attributes}
              onAddAnotherProductItem={() => this.setState({ createOrderItem: true })}
              onAddAnotherNonProductItem={() => this.setState({ createNonProductOrderItem: true })}
              onEditItem={(item: GQL.IOrderItem) => this.setState({ editOrderItem: item })}
              onDeleteItem={id => this.deleteOrderItem(id)}
            />
          </Tabs.TabPane>
          <Tabs.TabPane key={'2'} tab={'Invoices'}>
            <OrderInvoices
              domain={this.props.match.params.eshop}
              orderId={this.props.order.order.id}
              refetchOrder={this.props.order.refetch}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }

  /**
   * Odeslání dat pro založení nové položky objednávky
   * 
   * @param data
   */
  private async createOrderItem(data: ICreateOrderItem) {
    const result = await this.props.createOrderItem({
      variables: {
        orderItem: {
          variantId: data.variantId,
          quantity: data.quantity,
          orderId: this.props.order.order.id,
        },
      }
    });

    this.props.order.refetch();

    this.setState({
      createOrderItem: false
    });
  }

  /**
   * Uložení nové bezproduktové položky objednávky
   * 
   * @param data 
   */
  private async createNonProductOrderItem(data: ICreateNonProductOrderItem) {
    const result = await this.props.createNonProductOrderItem({
      variables: {
        orderItem: {
          orderId: this.props.order.order.id,
          title: data.title,
          name: data.name,
          sku: data.sku || '',
          recommendedPrice: data.recommendedPrice || null,
          price: data.price,
          quantity: data.quantity,
        },
      }
    });

    this.props.order.refetch();

    this.setState({
      createNonProductOrderItem: false,
    });
  }

  /**
   * Odeslání nových dat položky objednávky na server
   * 
   * @param data
   */
  private async updateOrderItem(data: IUpdateOrderItem) {
    if (this.state.editOrderItem) {
      await this.props.updateOrderItem({
        variables: {
          id: this.state.editOrderItem.id,
          orderItem: {
            recommendedPrice: data.recommendedPrice,
            price: data.price,
            quantity: data.quantity,
          },
        }
      });

      this.props.order.refetch();

      this.setState({
        editOrderItem: undefined
      });
    }
  }

  /**
   * Odeslání nových dat položky objednávky na server
   * 
   * @param data
   */
  private async updateNonProductOrderItem(data: IUpdateNonProductOrderItem) {
    if (this.state.editOrderItem) {
      await this.props.updateNonProductOrderItem({
        variables: {
          id: this.state.editOrderItem.id,
          orderItem: {
            title: data.title,
            name: data.name,
            sku: data.sku || '',
            recommendedPrice: data.recommendedPrice || null,
            price: data.price,
            quantity: data.quantity,
          },
        }
      });

      this.props.order.refetch();

      this.setState({
        editOrderItem: undefined
      });
    }
  }

  private async deleteOrderItem(id: string) {
    Modal.confirm({
      title: `Delete order item?`,
      content: <span>Are you sure you want to delete the order item?</span>,
      onOk: async () => {
        await this.props.deleteOrderItem({
          variables: {
            id
          }
        });

        this.props.order.refetch();
      }
    });
  }

  private onChangeSubject(newValue: string, lang: string) {
    if (this.state.letterData) {
      this.setState({
        letterData: {
          ...this.state.letterData,
          subject: { ...this.state.letterData.subject, [lang]: newValue }
        }
      });
    }
  }

  private onChangeMessage(newVal: string, lang) {
    if (this.state.letterData) {
      this.setState({
        letterData: {
          ...this.state.letterData,
          text: { ...this.state.letterData.subject, [lang]: newVal }
        }
      });
    }
  }

  private onChangeAttachment(name: string, newVal: boolean) {
    if (this.state.letterData) {
      this.setState({
        letterData: {
          ...this.state.letterData,
          [name]: newVal,
        }
      });
    }
  }

  private async sendComment(comment: string, sendMessage: boolean) {
    if (!this.props.createOrderComment) {
      return;
    }

    await this.props.createOrderComment({
      variables: {
        sendEmail: sendMessage,
        value: comment,
        orderId: this.props.order.order.id
      }
    });

    this.props.orderComments.refetch();
  }

  private async onUploadPurchaseQBOrder(order: GQL.IOrder) {
    if (!this.props.uploadQBPurchaseOrder) {
      return;
    }

    const result = await this.props.uploadQBPurchaseOrder({
      variables: {
        orderId: order.id
      }
    });

    if (result && result.data && result.data.uploadPurchaseQBOrder) {
      return notification['success']({
        message: 'Info',
        description: `Purchase order has been sent.`
      });
    }

    notification['error']({
      message: 'Error',
      description: 'Unexpectedly purchase order could not be uploaded'
    });
  }

  /**
   * Odeslání objednávky do Pohody
   * 
   * @param order 
   */
  private async onUploadToPohoda(order: GQL.IOrder) {
    if(!this.props.uploadToPohoda) {
      return;
    }

    const result = await this.props.uploadToPohoda({
      variables: {
        orderId: order.id
      }});

    if(result && result.data && result.data.uploadToPohoda) {
      return notification['success']({
        message: 'Info',
        description: `Order has been sent to Pohoda.`
      });
    }

    notification['error']({
      message: 'Error',
      description: 'Unexpectedly order could not be uploaded to Pohoda'
    })

  }

  private sendMessage() {
    if (this.props.sendOrderEmail && this.state.letterData) {
      this.props.sendOrderEmail({
        variables: {
          orderId: this.props.order.order.id,
          recipient: this.props.order.order.email,
          subject: this.getSubject(),
          body: this.getMessage(),
          attachments: {
            invoice: this.state.letterData.attachmentInvoice,
            proforma: this.state.letterData.attachmentProforma,
          },
        }
      });

      notification['success']({
        message: 'Info',
        description: `Message sent`
      });
    }

    this.setState({ letterData: undefined });
  }

  private getSubject() {
    const order = this.props.order.order;

    const { letterData } = this.state;

    if (letterData == undefined) {
      return '';
    }

    let subject = letterData.subject[this.props.order.order.language];
    subject = parseLetterData(order, subject);

    return subject;
  }

  private getMessage() {
    const order = this.props.order.order;

    const { letterData } = this.state;

    if (letterData == undefined) {
      return '';
    }

    let message = letterData.text[order.language];
    message = parseLetterData(order, message);

    return message;
  }

  /**
   * Aktualizace dat objednávky
   * 
   * @param newData 
   */
  private async onUpdate(newData: any) {
    if (!this.props.updateOrder) {
      return;
    }

    const action = newData._action;

    const data = (await this.props.updateOrder({
      variables: {
        orderId: this.props.order.order.id,
        data: newData,
      }
    })) as any;

    this.props.order.refetch();

    notification['success']({
      message: 'Info',
      description: `Order data successfuly changed`
    });

    if (action === 'saveOrderSent_ChangeOrderStatus' || action === 'saveOrderSent_ChangeOrderStatus_SendEmail') {
      // notifikace změny stavu
      notification['success']({
        message: 'Info',
        description: `External state successfuly changed`
      });

      if (action === 'saveOrderSent_ChangeOrderStatus_SendEmail') {
        // notifikace odeslání emailu
        notification['success']({
          message: 'Info',
          description: `Message sent`
        });
      }
    }

    return true;
  }

  private async onChangeExternalOrderState(newStateId: string) {
    if (!this.props.changeState) {
      return;
    }

    const data = (await this.props.changeState({
      variables: {
        orderId: this.props.order.order.id,
        newStateId: newStateId,
        domain: this.props.match.params.eshop
      }
    })) as any;

    this.props.order.refetch();

    this.setState({ 
      letterData: data.data.changeExternalOrderState
    });

    notification['success']({
      message: 'Info',
      description: `External state successfuly changed`
    });
  }
}

export default withRouter(OrderView);



// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView.tsx